import { render, staticRenderFns } from "./Ref.vue?vue&type=template&id=6f029430&scoped=true"
import script from "./Ref.vue?vue&type=script&lang=js"
export * from "./Ref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f029430",
  null
  
)

export default component.exports